/**
 * Claim names the dashboard reads off the current user. They are BDC AI's own names, not
 * an identity provider's — the role now arrives from the API's `/auth/me` rather than
 * from a token claim, and these keep the shape the principal helpers already expect.
 */
export const AUTH_CLAIMS = {
  ROLE: 'role',
} as const

export type UserRole = 'SUPER_ADMIN' | 'STAFF'
